import type { Properties as CSSProperties } from "csstype";
import { TransitionStatus } from "react-transition-group";
import styled from "styled-components";
import { CLOSED_WIDTH, OPEN_WIDTH } from "../../Sidebar.constants.js";
import { StyledSidebarBrandContainer } from "../SidebarBrand/SidebarBrand.style.js";
import { StyledSidebarSection } from "../SidebarSection/SidebarSection.style.js";

type StyledSidebarInnerProps = {
    open: boolean;
    backgroundColor?: CSSProperties["backgroundColor"];
    transitionState: TransitionStatus;
    transitionDuration: number;
    floating?: boolean;
};

export const StyledSidebarInner = styled.div<StyledSidebarInnerProps>`
    overflow-y: auto;
    overflow-x: hidden;
    padding: ${(props) => `${props.theme.spacing[24]} ${props.theme.spacing[16]}`};
    height: 100%;
    display: flex;
    flex-direction: column;
    position: ${({ floating }) => (floating ? "absolute" : "relative")};
    top: 0;
    left: 0;
    bottom: 0;
    flex-shrink: 0;
    z-index: ${({ floating, theme }) => (floating ? theme.elevationLevels.three : "unset")};
    width: ${({ transitionState }) => (transitionState === "entered" ? OPEN_WIDTH : CLOSED_WIDTH)};

    background-color: ${({ backgroundColor, transitionState, floating }) =>
        transitionState === "entered" && floating && backgroundColor ? backgroundColor : "transparent"};

    transition:
        width ${({ transitionDuration }) => transitionDuration}ms linear,
        background-color ${({ transitionDuration }) => transitionDuration * 1}ms linear,
        box-shadow ${({ transitionDuration }) => transitionDuration * 1}ms linear;
    box-shadow: ${({ open, floating, theme }) => (open && floating ? theme.shadows.popover : undefined)};
    will-change: width;

    &:not(:hover) {
        overflow-y: hidden;
        overflow-x: hidden;
    }

    &:not(:hover)::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0);
        border-color: rgba(0, 0, 0, 0);
    }

    &:not(:hover)::-webkit-scrollbar {
        background-color: rgba(0, 0, 0, 0);
        border-color: rgba(0, 0, 0, 0);
    }

    > ${StyledSidebarBrandContainer} {
        flex-shrink: 0;
    }
    > ${StyledSidebarSection} {
        flex-shrink: 0;
    }
`;
